export const zoomOutIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill="none" stroke="currentColor" stroke-width="1.2" d="M1 7.667a6.667 6.667 0 1 0 13.334 0A6.667 6.667 0 0 0 1 7.667zM17 17l-4.619-4.619M4.692 7.769h6.154"/></svg>`,
    name: 'zoom-out'
};